module.exports = __webpack_public_path__ + "img/south-korea.ebb1f472.svg";